<div class="trip-loggedin-container pt-lg-2 pl-md-2">
  <div *ngIf="tripDetails?.vacationTripDetails">
    <span class="label-heading">
      {{ tripContent ? tripContent.deltaVacationTitle : 'Your Delta Vacation' }}
    </span>
    <div class="row">
      <div class="col-lg-5 city-state">
        <span *ngIf="iropAemMessage !== ''" class="message-alert-icon"></span>
        <span [ngClass]="{ 'mytrips_text-modify': isCityNameOnly }">
          {{ tripDetails?.vacationTripDetails?.depCityName }}
        </span>
      </div>
      <div class="col-lg-2 col-sm-12 m-lg-0 trip-date text-nowrap">
        <div [ngClass]="{ 'trip-date-left-space': iropAemMessage !== '' }">
          {{ tripDetails?.vacationTripDetails?.dateRange }}
        </div>
        <div
          *ngIf="iropAemMessage !== ''"
          class="warning-alert-message d-lg-none d-md-block"
        >
          {{ iropAemMessage }}
        </div>
      </div>

      <div
        *ngIf="!tripDetails?.vacationTripDetails?.checkinLink"
        class="col-lg-5 view-trip-details"
      >
        <a
          (click)="mytripsTodayClick($event)"
          [ngClass]="{
            'view-trip-btn-danger':
              tripDetails?.vacationTripDetails?.iropMessage &&
              tripDetails?.vacationTripDetails?.iropMessage.trim() !== '',
            'btn-outline-white':
              !tripDetails?.vacationTripDetails?.iropMessage ||
              tripDetails?.vacationTripDetails?.iropMessage.trim() === ''
          }"
          class="btn rounded-0 focusable-element"
          href="javascript:void(0)"
        >
          {{
            tripContent ? tripContent.viewTripDetailsTitle : 'View Trip Details'
          }}
          <form
            #flyoutTodayMytripsForm
            [action]="formActionFlight"
            id="flyout-todayTrip-link"
            method="POST"
            novalidate
          >
            <input
              name="confirmationNo"
              type="hidden"
              value="{{ confirmationNo }}"
            />
            <input name="firstName" type="hidden" value="{{ firstName }}" />
            <input name="lastName" type="hidden" value="{{ lastName }}" />
            <input name="flagFromMyProfile" type="hidden" value="Y" />
            <input name="interstitial" type="hidden" value="true" />
          </form>
        </a>
      </div>
      <div
        *ngIf="
          tripDetails?.vacationTripDetails?.checkinLink &&
          tripDetails?.vacationTripDetails?.checkedIn === false
        "
        class="col-lg-5 col-md-12 view-trip-details"
      >
        <a
          (click)="mytripsTodayClick($event)"
          [ngClass]="{
            'view-trip-btn-danger':
              tripDetails?.vacationTripDetails?.iropMessage &&
              tripDetails?.vacationTripDetails?.iropMessage.trim() !== '',
            'btn-outline-white':
              !tripDetails?.vacationTripDetails?.iropMessage ||
              tripDetails?.vacationTripDetails?.iropMessage.trim() === ''
          }"
          class="btn rounded-0 focusable-element"
          href="javascript:void(0)"
        >
          {{
            tripContent ? tripContent.viewTripDetailsTitle : 'View Trip Details'
          }}
          <form
            #flyoutTodayMytripsForm
            [action]="formActionFlight"
            id="flyout-todayTrip-link"
            method="POST"
            novalidate
          >
            <input
              name="confirmationNo"
              type="hidden"
              value="{{ confirmationNo }}"
            />
            <input name="firstName" type="hidden" value="{{ firstName }}" />
            <input name="lastName" type="hidden" value="{{ lastName }}" />
            <input name="flagFromMyProfile" type="hidden" value="Y" />
            <input name="interstitial" type="hidden" value="true" />
          </form>
        </a>
        <a
          href="javascript:void(0)"
          class="btn rounded-0 btn-danger"
          (click)="checkIn(tripDetails?.vacationTripDetails?.checkinLink)"
        >
          {{ tripContent ? tripContent.checkInTitle : 'Check In' }}
        </a>
      </div>
      <div
        *ngIf="
          tripDetails?.vacationTripDetails?.checkinLink !== null &&
          tripDetails?.vacationTripDetails?.checkedIn === true
        "
        class="col-lg-5 view-trip-details"
      >
        <a
          (click)="mytripsTodayClick($event)"
          [ngClass]="{
            'view-trip-btn-danger':
              tripDetails?.vacationTripDetails?.iropMessage &&
              tripDetails?.vacationTripDetails?.iropMessage.trim() !== '',
            'btn-outline-white':
              !tripDetails?.vacationTripDetails?.iropMessage ||
              tripDetails?.vacationTripDetails?.iropMessage.trim() === ''
          }"
          class="btn rounded-0 focusable-element"
          href="javascript:void(0)"
        >
          {{
            tripContent ? tripContent.viewTripDetailsTitle : 'View Trip Details'
          }}
          <form
            #flyoutTodayMytripsForm
            [action]="formActionFlight"
            id="flyout-todayTrip-link"
            method="POST"
            novalidate
          >
            <input
              name="confirmationNo"
              type="hidden"
              value="{{ confirmationNo }}"
            />
            <input name="firstName" type="hidden" value="{{ firstName }}" />
            <input name="lastName" type="hidden" value="{{ lastName }}" />
            <input name="flagFromMyProfile" type="hidden" value="Y" />
            <input name="interstitial" type="hidden" value="true" />
          </form>
        </a>
        <a
          class="btn rounded-0 btn-outline-white btn-boarding-pass"
          href="javascript:void(0)"
          (click)="checkIn(tripDetails?.vacationTripDetails?.checkinLink)"
        >
          {{
            tripContent
              ? tripContent.viewBoardingPassTitle
              : 'View Boarding Pass'
          }}
        </a>
      </div>
    </div>
    <div
      *ngIf="iropAemMessage !== ''"
      class="warning-alert-message d-lg-block d-md-none d-sm-none"
    >
      {{ iropAemMessage }}
    </div>
  </div>

  <div *ngIf="tripDetails?.carTripDetails">
    <span class="label-heading">
      {{
        tripContent ? tripContent.carReservationTitle : ' Your Car Reservation'
      }}
    </span>
    <div class="row">
      <div class="col-lg-5 city-state">
        <span class="mytrips_text-modify">
          {{ tripDetails?.carTripDetails?.vendorName }}
        </span>
        {{ tripDetails?.carTripDetails.pickupCity }}
      </div>
      <div class="col-lg-2 m-lg-0 trip-date text-nowrap">
        {{ tripDetails?.carTripDetails?.dateRange }}
      </div>
      <div class="col-lg-5 view-trip-details">
        <a
          (click)="mytripsTodayClick($event)"
          class="btn rounded-0 btn-outline-white focusable-element"
          href="javascript:void(0)"
        >
          {{
            tripContent ? tripContent.viewTripDetailsTitle : 'View Trip Details'
          }}
          <form
            #flyoutTodayMytripsForm
            [action]="formActionFlight"
            id="flyout-todayTrip-link"
            method="POST"
            novalidate
          >
            <input
              name="confirmationNo"
              type="hidden"
              value="{{ confirmationNo }}"
            />
            <input name="firstName" type="hidden" value="{{ firstName }}" />
            <input name="lastName" type="hidden" value="{{ lastName }}" />
            <input name="flagFromMyProfile" type="hidden" value="Y" />
            <input name="interstitial" type="hidden" value="true" />
          </form>
        </a>
      </div>
    </div>
  </div>
  <div *ngIf="tripDetails?.flightTripDetails">
    <span class="label-heading">
      {{ tripContent ? tripContent.upComingTripTitle : ' Your Upcoming Trip' }}
    </span>
    <div class="row">
      <div class="col-lg-5 city-state">
        <span *ngIf="iropAemMessage !== ''" class="message-alert-icon"></span>
        {{ tripDetails?.flightTripDetails?.destinationCity }}
        {{ tripDetails?.flightTripDetails?.pickupCity }}
      </div>
      <div class="col-lg-2 col-sm-12 m-lg-0 trip-date text-nowrap">
        <div [ngClass]="{ 'trip-date-left-space': iropAemMessage !== '' }">
          {{ tripDetails?.flightTripDetails?.dateRange }}
        </div>
        <div
          *ngIf="iropAemMessage !== ''"
          [innerHTML]="iropAemMessage"
          class="warning-alert-message d-lg-none d-md-block"
        >
          {{ iropAemMessage }}
        </div>
      </div>
      <div
        *ngIf="!tripDetails?.flightTripDetails?.checkinLink"
        class="col-lg-5 view-trip-details"
      >
        <a
          (click)="mytripsTodayClick($event)"
          [ngClass]="{
            'view-trip-btn-danger': iropAemMessage !== '',
            'btn-outline-white': iropAemMessage === ''
          }"
          class="btn rounded-0 focusable-element"
          href="javascript:void(0)"
        >
          {{
            tripContent ? tripContent.viewTripDetailsTitle : 'View Trip Details'
          }}
          <form
            #flyoutTodayMytripsForm
            [action]="formActionFlight"
            id="flyout-todayTrip-link"
            method="POST"
            novalidate
          >
            <input
              name="confirmationNo"
              type="hidden"
              value="{{ confirmationNo }}"
            />
            <input name="firstName" type="hidden" value="{{ firstName }}" />
            <input name="lastName" type="hidden" value="{{ lastName }}" />
            <input name="flagFromMyProfile" type="hidden" value="Y" />
            <input name="interstitial" type="hidden" value="true" />
          </form>
        </a>
      </div>
      <div
        *ngIf="
          tripDetails?.flightTripDetails?.checkinLink &&
          tripDetails?.flightTripDetails?.checkedIn === false
        "
        class="col-lg-5 col-md-12 view-trip-details"
      >
        <a
          (click)="mytripsTodayClick($event)"
          [ngClass]="{
            'view-trip-btn-danger': iropAemMessage !== '',
            'btn-outline-white': iropAemMessage === ''
          }"
          class="btn rounded-0 focusable-element"
          href="javascript:void(0)"
        >
          {{
            tripContent ? tripContent.viewTripDetailsTitle : 'View Trip Details'
          }}
          <form
            #flyoutTodayMytripsForm
            [action]="formActionFlight"
            id="flyout-todayTrip-link"
            method="POST"
            novalidate
          >
            <input
              name="confirmationNo"
              type="hidden"
              value="{{ confirmationNo }}"
            />
            <input name="firstName" type="hidden" value="{{ firstName }}" />
            <input name="lastName" type="hidden" value="{{ lastName }}" />
            <input name="flagFromMyProfile" type="hidden" value="Y" />
            <input name="interstitial" type="hidden" value="true" />
          </form>
        </a>
        <a
          class="btn rounded-0 btn-danger"
          href="javascript:void(0)"
          (click)="checkIn(tripDetails?.flightTripDetails?.checkinLink)"
        >
          {{ tripContent ? tripContent.checkInTitle : ' Check In' }}
        </a>
      </div>
      <div
        *ngIf="
          tripDetails?.flightTripDetails?.checkinLink !== null &&
          tripDetails?.flightTripDetails?.checkedIn === true
        "
        class="col-lg-5 view-trip-details"
      >
        <a
          (click)="mytripsTodayClick($event)"
          [ngClass]="{
            'view-trip-btn-danger': iropAemMessage !== '',
            'btn-outline-white': iropAemMessage === ''
          }"
          class="btn rounded-0 focusable-element"
          href="javascript:void(0)"
        >
          {{
            tripContent
              ? tripContent.viewTripDetailsTitle
              : ' View Trip Details'
          }}
          <form
            #flyoutTodayMytripsForm
            [action]="formActionFlight"
            id="flyout-todayTrip-link"
            method="POST"
            novalidate
          >
            <input
              name="confirmationNo"
              type="hidden"
              value="{{ confirmationNo }}"
            />
            <input name="firstName" type="hidden" value="{{ firstName }}" />
            <input name="lastName" type="hidden" value="{{ lastName }}" />
            <input name="flagFromMyProfile" type="hidden" value="Y" />
            <input name="interstitial" type="hidden" value="true" />
          </form>
        </a>
        <a
          class="btn rounded-0 btn-outline-white btn-boarding-pass"
          href="javascript:void(0)"
          (click)="checkIn(tripDetails?.flightTripDetails?.checkinLink)"
        >
          {{
            tripContent
              ? tripContent.viewBoardingPassTitle
              : 'View Boarding Pass'
          }}
        </a>
      </div>
    </div>
    <div
      *ngIf="iropAemMessage !== ''"
      [innerHTML]="iropAemMessage"
      class="warning-alert-message d-lg-block d-md-none d-sm-none"
    >
      {{ iropAemMessage }}
    </div>
  </div>
</div>
